<template>
	<div v-if="visible" class="xsmall fd-mod" :class="clazz" :style="style">
		<div class="fd-mod-label">{{ env.msg('agenda.modified') }}:</div>
		<div class="fd-mod-date">{{ modified }}</div>
		<div class="fd-mod-user">{{ modifiedBy }}</div>
		<div class="fd-mod-label">{{ env.msg('agenda.created') }}:</div>
		<div class="fd-mod-date">{{ created }}</div>
		<div class="fd-mod-user">{{ createdBy }}</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {injectEnv} from "@fd/Environment";
import usePart, {getter, type PartProps, partProps} from "@fd/Part";
import type {Mod} from "@t/fd/fixed/Mod";
import {parseDate, type ParsedDate, format as formatForHumans} from "@t/util/DateUtil";
import {injectFindList} from "@fd/PartInjectKeys";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const mod = computed<Mod>(() => props.part as Mod);
const { visible, clazz, style, localData, formData } = usePart(props);

const env = injectEnv();
const findList = injectFindList();

const modifiedRaw = computed<ParsedDate>(() => parseDate(getter(localData.value as FormData, mod.value.modifiedProperty || "modified", formData.value)));
const modifiedByRaw = computed<any>(() => getter(localData.value as FormData, mod.value.modifiedByProperty || "modifiedBy", formData.value));
const createdRaw = computed<ParsedDate>(() => parseDate(getter(localData.value as FormData, mod.value.createdProperty || "entered", formData.value)));
const createdByRaw = computed<any>(() => getter(localData.value as FormData, mod.value.createdByProperty || "enteredBy", formData.value));

const modified = computed<string>(() => formatForHumans(modifiedRaw.value, env));
const modifiedBy = computed<string>(() => formatUser(modifiedByRaw.value));
const created = computed<string>(() => formatForHumans(createdRaw.value, env));
const createdBy = computed<string>(() => formatUser(createdByRaw.value));

function formatUser(uid: number | string):string {
	let userListItem = null;
	if (typeof uid === "string") {
		const list = findList("ALL_USERS");
		userListItem = list.value.find((li) => li.value === uid);
	} else if (typeof uid === "number") {
		const list = findList("ALL_USER_IDS");
		userListItem = list.value.find((li) => li.value === uid);
	}
	if (userListItem) return userListItem.name;
	return "-";
}

</script>

<style>
.fd-mod {
	display: inline-grid;
	grid-template-columns: auto auto auto;
	column-gap: 4px;
}
.fd-mod-date {
	font-feature-settings: var(--font-features-data);
	color: var(--fg);
}
.fd-mod-label {
	color: var(--fg);
}
</style>